<div class="warehouse-container">
  <app-analytics-card
    [title]="'ANALYTICS.TRAY_DETAILS' | translate"
    [infos]="'ANALYTICS.OCCUPATION_TRAYS_COMPARTMENTS_POPOVER_INFO' | translate"
  >
    <app-analytics-widget [query]="'count-trays'" [filters]="filters" [hideNoData]="true">
      <ng-template let-traysResult>
        <app-analytics-widget [query]="'count-compartments'" [filters]="filters" [hideNoData]="true">
          <ng-template let-compartmentResult>
            <div class="tray-detail-card">
              <div class="data-card">
                <app-icam-icon iconName="total-trays" iconHeight="100%" />
                <div class="info">
                  <span class="subtitle">{{ 'ANALYTICS.TOTAL_TRAYS' | translate }}</span>
                  <span class="value">{{
                    traysResult && traysResult.rows && traysResult.rows.length
                      ? trayValueForStatus(traysResult, 'total', 'value')
                      : 0
                  }}</span>
                </div>
              </div>
              <div class="data-card">
                <app-icam-icon iconName="total-compartments" iconHeight="100%" />
                <div class="info">
                  <span class="subtitle">{{ 'ANALYTICS.TOTAL_COMPARTMENTS' | translate }}</span>
                  <span class="value">{{
                    compartmentResult && compartmentResult.rows && compartmentResult.rows.length
                      ? compartmentResult.rows[0].total
                      : 0
                  }}</span>
                </div>
              </div>

              <div class="data-card">
                <app-icam-icon iconName="tray-full" iconHeight="100%" />
                <div class="info">
                  <span class="subtitle">{{ 'ANALYTICS.FULL' | translate }}</span>
                  <span class="value">{{
                    traysResult && traysResult.rows && traysResult.rows.length
                      ? trayValueForStatus(traysResult, 'pieno', 'value')
                      : 0
                  }}</span>
                </div>
              </div>
              <div class="data-card">
                <app-icam-icon iconName="tray-partial" iconHeight="100%" />
                <div class="info">
                  <span class="subtitle">{{ 'ANALYTICS.PARTIAL' | translate }}</span>
                  <span class="value">{{
                    traysResult && traysResult.rows && traysResult.rows.length
                      ? trayValueForStatus(traysResult, 'parzialmente pieno', 'value')
                      : 0
                  }}</span>
                </div>
              </div>
              <div class="data-card">
                <app-icam-icon iconName="tray-empty" iconHeight="100%" />
                <div class="info">
                  <span class="subtitle">{{ 'ANALYTICS.EMPTY' | translate }}</span>
                  <span class="value">{{
                    traysResult && traysResult.rows && traysResult.rows.length
                      ? trayValueForStatus(traysResult, 'vuoto', 'value')
                      : 0
                  }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </app-analytics-widget>
      </ng-template>
    </app-analytics-widget>
  </app-analytics-card>

  <div class="saturation-section-container">
    <app-analytics-card
      [title]="'ANALYTICS.TRAY_OCCUPATION_DETAILS' | translate"
      [infos]="'ANALYTICS.SURFACE_SATURATION_POPOVER_INFO' | translate"
    >
      <app-analytics-widget [query]="'machine-area-saturation'" [filters]="filters">
        <ng-template let-result>
          @if (result && result.rows && result.rows.length) {
            <div class="saturation-card-container">
              @if (result.rows[0]; as row) {
                <div class="saturation-card">
                  <div class="percentage-cell">
                    <app-icam-icon iconName="saturation-area" iconHeight="100%" />
                    <div class="info">
                      <span class="subtitle">{{ 'ANALYTICS.SURFACE_SATURATION' | translate }}</span>
                      <span class="value">{{ +row.saturation_percentage | number: '1.2-2' }}%</span>
                    </div>
                  </div>
                  <app-divider [orientation]="'vertical'" class="vertical-divider main-divider"></app-divider>
                  <app-divider [orientation]="'horizontal'" class="horizontal-divider main-divider"></app-divider>
                  <div class="data-section">
                    <div class="data-cell">
                      <app-icam-icon iconName="saturation-area-empty" iconHeight="100%" />
                      <div class="info">
                        <span class="subtitle">{{ 'ANALYTICS.TOTAL_TRAY_OCCUPATION' | translate }}</span>
                        <span class="value">{{ +row.total_area | number: '1.0-0' }} m²</span>
                      </div>
                    </div>
                    <app-divider [orientation]="'horizontal'" class="horizontal-divider"></app-divider>
                    <div class="data-cell">
                      <app-icam-icon iconName="saturation-area-partial" iconHeight="100%" />
                      <div class="info">
                        <span class="subtitle">{{ 'ANALYTICS.SURFACE_TRAY_OCCUPATION' | translate }}</span>
                        <span class="value">{{ +row.total_compartment_area_m2 | number: '1.0-0' }} m²</span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </ng-template>
      </app-analytics-widget>
    </app-analytics-card>

    <app-analytics-card
      [title]="'ANALYTICS.VOLUME_SATURATION_DETAILS' | translate"
      [infos]="'ANALYTICS.VOLUME_SATURATION_POPOVER_INFO' | translate"
    >
      <app-analytics-widget [query]="'machine-volume-saturation'" [filters]="filters">
        <ng-template let-result>
          @if (result && result.rows && result.rows.length) {
            <div class="saturation-card-container">
              @if (result.rows[0]; as row) {
                <div class="saturation-card">
                  <div class="percentage-cell">
                    <app-icam-icon iconName="saturation-volume" iconHeight="100%" />
                    <div class="info">
                      <span class="subtitle">{{ 'ANALYTICS.VOLUME_SATURATION' | translate }}</span>
                      <span class="value">{{ +row.saturation_percentage | number: '1.2-2' }}%</span>
                    </div>
                  </div>
                  <app-divider [orientation]="'vertical'" class="vertical-divider main-divider"></app-divider>
                  <app-divider [orientation]="'horizontal'" class="horizontal-divider main-divider"></app-divider>
                  <div class="data-section">
                    <div class="data-cell">
                      <app-icam-icon iconName="saturation-volume-empty" iconHeight="100%" />
                      <div class="info">
                        <span class="subtitle">{{ 'ANALYTICS.TOTAL_TRAY_OCCUPATION' | translate }}</span>
                        <span class="value">{{ +row.total_volume | number: '1.0-0' }} m³</span>
                      </div>
                    </div>
                    <app-divider [orientation]="'horizontal'" class="horizontal-divider"></app-divider>
                    <div class="data-cell">
                      <app-icam-icon iconName="saturation-volume-partial" iconHeight="100%" />
                      <div class="info">
                        <span class="subtitle">{{ 'ANALYTICS.VOLUME_TRAY_OCCUPATION' | translate }}</span>
                        <span class="value">{{ +row.total_compartment_volume_m3 | number: '1.0-0' }} m³</span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </ng-template>
      </app-analytics-widget>
    </app-analytics-card>
  </div>

  <div class="product-section-container">
    <app-analytics-card [title]="'ANALYTICS.TEN_MOST_REQUESTED' | translate" [exportable]="true">
      <app-analytics-export-button
        export-button
        [isExporting]="isExportingMostRequested()"
        [filters]="filters"
        (exportFormat)="onExportFormatSelected($event, 'ten-most-requested-articles')"
      >
      </app-analytics-export-button>

      <app-analytics-widget [query]="'ten-most-requested-articles'" [filters]="filters">
        <ng-template let-result>
          @if (result && result.rows && result.rows.length) {
            <table>
              <thead>
                <tr>
                  <th>{{ 'ANALYTICS.TABLE_HEADERS.ID_PRODUCT' | translate }}</th>
                  <th>{{ 'ANALYTICS.TABLE_HEADERS.PRD_NAME' | translate }}</th>
                  <th>{{ 'ANALYTICS.TABLE_HEADERS.MISSION_COUNT' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of result.rows; track row; let i = $index) {
                  <tr [ngClass]="i % 2 === 1 ? 'odd' : ''">
                    <td>{{ row.idProduct }}</td>
                    <td>{{ row.prd_name }}</td>
                    <td>{{ row.mission_count }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </ng-template>
      </app-analytics-widget>
    </app-analytics-card>

    <app-analytics-card [title]="'ANALYTICS.TEN_LEAST_REQUESTED' | translate" [exportable]="true">
      <app-analytics-export-button
        export-button
        [isExporting]="isExportingLeastRequested()"
        [filters]="filters"
        (exportFormat)="onExportFormatSelected($event, 'ten-least-requested-articles')"
      >
      </app-analytics-export-button>

      <app-analytics-widget [query]="'ten-least-requested-articles'" [filters]="filters">
        <ng-template let-result>
          @if (result && result.rows && result.rows.length) {
            <table>
              <thead>
                <tr>
                  <th>{{ 'ANALYTICS.TABLE_HEADERS.ID_PRODUCT' | translate }}</th>
                  <th>{{ 'ANALYTICS.TABLE_HEADERS.PRD_NAME' | translate }}</th>
                  <th>{{ 'ANALYTICS.TABLE_HEADERS.MISSION_COUNT' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of result.rows; track row; let i = $index) {
                  <tr [ngClass]="{ odd: i % 2 === 1 }">
                    <td>{{ row.idProduct }}</td>
                    <td>{{ row.prd_name }}</td>
                    <td>{{ row.mission_count }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </ng-template>
      </app-analytics-widget>
    </app-analytics-card>
  </div>
</div>
